import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { styles, colors, spacing } = theme.busbud;
  const border_style = `${styles.borderWidth.sm} solid ${colors.border.primary.opaque}`;

  return {
    header: {
      padding: spacing(2.5)
    },
    content: { height: "100%" },
    buttonContainer: {
      position: "sticky",
      bottom: 0,
      right: 0,
      width: "inherit",
      borderTop: border_style,
      padding: spacing(3),
      backgroundColor: colors.background.primary.opaque,
      // Extra padding when the device needs some safe space in the bottom
      paddingBottom: `calc(env(safe-area-inset-bottom, 0) + ${spacing(3.5)})`
    },
    lastItem: {
      marginBottom: spacing(20)
    },
    loader: {
      margin: "auto"
    },
    cardHeader: {
      padding: spacing(2, 2.5),
      minHeight: "unset"
    },
    cardWrapper: {
      overflow: "unset"
    },
    cardContent: {
      position: "relative",
      backgroundColor: colors.background.primary.opaque,
      borderRadius: styles.rounding.xl,
      outline: border_style,
      paddingBottom: spacing(6),
      "&:not(:first-child)": {
        marginTop: spacing(-6)
      },
      "&:last-child": {
        marginBottom: spacing(-6)
      }
    },
    innerCardContent: {
      paddingTop: 0
    },
    urgencyBannerParent: {
      "&:empty": {
        display: "none"
      },
      margin: spacing(0, 2, 2, 2)
    }
  };
});
